<template>

<div class="group l_min-footspace l_min-headspace" :ref="refs['quoteDelivery']">


  <div class="group-header l_no-footspace" :id="`${builder.panelFinish.fieldName}Title`">
    <div class="group-title">Schedule Delivery</div>
    <div class="group-help">Within Adelaide Metro area. &nbsp;<a href="/support/delivery-information/" target="_blank" @click.stop.prevent="showDeliveryExplanation">Find out more</a></div>
  </div>

  <Selector
    :key=builder.delivery.fieldName
    :field-name=builder.delivery.fieldName
    :display-type=builder.delivery.displayType
    :options=builder.delivery.options
    :selected=builder.quote[builder.delivery.fieldName]
    options-source="deliveryOptions"
    scope="quote"
    @select-option="updateDelivery"
  ></Selector>

  <div class="wardrobenotice l_light-blue" style="padding: 0;" v-if="isPickup && builder.delivery.pickupDetails.length">
    <div class="wardrobenotice-inner" v-html="builder.delivery.pickupDetails" style="margin-top: 20px; font-size: 80%;">
    </div>
  </div>

  <div class="wardrobe-inner" style="margin-top: 10px;" v-if="builder.quote[builder.delivery.fieldName] == 'request'">
    <div class="wardrobe-main l_p0 l_wrap">
      <div class="wardrobe-cost l_promocode l_delivery">
        <label for="promoCode" class="wardrobe-cost-label">Delivery Date Request</label>
        <div class="wardrobe-cost-input">
          <!-- <input
          type="text"
          id="promoCode"
          name="promoCode"
          placeholder="Enter your code here"
          v-model="promoCodeInput"
          @focus="$event.target.select()"
          @keydown.enter.prevent="updatePromoCode($event)"
          aria-required
          autocomplete="off"> -->
          <input
          type="date"
          name="deliveryDateRequest"
          v-model="deliveryDateValue"
          :min="deliveryDateMin"
          :max="deliveryDateMax"
          pattern="\d{4}-\d{2}-\d{2}"
          @change="updateDeliveryDate()"
          @keydown.enter.prevent="updateDeliveryDate()">
          <!-- <div class="feedback" v-if="promoCodeResponse || builder.quote.promoCodeApplied">
            <template v-if="builder.quote.promoCodeApplied">
              <svg class="icon"><use href="#check"></use></svg>
              Valid
            </template>
            <template v-else>
              Invalid
            </template>
          </div> -->
          <!-- <button class="button l_base l_strong" @click.stop="updatePromoCode($event)">Check</button> -->
        </div>
      </div>
    </div>
  </div>

</div>

</template>

<script setup>

import { ref, onMounted, computed } from 'vue'

var _ = require('lodash');
const dayjs = require('dayjs')
import dayjsBusinessDays from 'dayjs-business-days';
dayjs.extend(dayjsBusinessDays);

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function updateDelivery(prop, opt) {
  let submitData = {};
  submitData[builder.delivery.fieldName] = opt['id'];
  builder.actionPost('quote/update', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.$patch((state) => {
        state.quote = response.quote;
      })
      deliveryDateValue.value = deliveryDate;
    }
  });
}

function updateDeliveryDate() {
  let submitData = {
    'deliveryDate': deliveryDateValue
  };
  builder.actionPost('quote/update', submitData, false).then(response => {
    if (_.isObject(response)) {
      builder.isSubmitted = false;
      builder.$patch((state) => {
        state.quote = response.quote;
      })
    }
  });
}

function showDeliveryExplanation() {
  lightbox.open(builder.delivery.details);
}

const isPickup = computed(() => {
  return builder.quote[builder.delivery.fieldName] == 'pickup';
})

// dates
let now = dayjs()
const isNextBusinessDay = dayjs().format('H') > 17
const businessDays = 15 + ( isNextBusinessDay ? 1 : 0 )
const deliveryDateMin = now.businessDaysAdd(businessDays).format('YYYY-MM-DD')
const deliveryDateMax = now.businessDaysAdd(90).format('YYYY-MM-DD')
const deliveryDate = dayjs(builder.quote.deliveryDateRequest ?? deliveryDateMin).format('YYYY-MM-DD')
const deliveryDateValue = ref(deliveryDate)

// init refs
let refHandles = [
  'quoteDelivery',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});

</script>
